module.exports = __webpack_public_path__ + "img/link2.bef9f4e7.png";